// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rag-page {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.rag-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.rag-header-actions {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}

.rag-header-actions .btn-danger {
  padding: 0.75rem 1rem;
  background-color: #e74c3c;
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.rag-header-actions .btn-danger:hover:not(:disabled) {
  background-color: #c0392b;
}

.rag-header-actions .btn-danger:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.rag-header h2 {
  margin: 0;
  color: #2c3e50;
}

.rag-content {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 1rem;
  flex: 1 1;
}

.documents-list {
  background: white;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.documents-list h3 {
  margin-top: 0;
  color: #2c3e50;
}

.empty-state {
  color: #7f8c8d;
  text-align: center;
  padding: 2rem 0;
}

.doc-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.doc-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  transition: background-color 0.2s;
}

.doc-item:hover {
  background-color: #f8f9fa;
}

.doc-item.active {
  background-color: #e3f2fd;
}

.doc-item:last-child {
  border-bottom: none;
}

.doc-info {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.doc-name {
  font-weight: 500;
  color: #2c3e50;
}

.doc-date {
  font-size: 0.875rem;
  color: #7f8c8d;
}

.doc-actions {
  display: flex;
  gap: 0.5rem;
}

.btn-icon {
  background: none;
  border: none;
  font-size: 1.25rem;
  cursor: pointer;
  padding: 0.25rem;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.btn-icon:hover {
  opacity: 1;
}

.btn-danger:hover {
  color: #e74c3c;
}

.pdf-viewer-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  min-height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pdf-viewer-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.placeholder-content {
  text-align: center;
  color: #7f8c8d;
}

.placeholder-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
  opacity: 0.5;
}

.placeholder-content h3 {
  margin: 0 0 0.5rem 0;
  color: #2c3e50;
  font-size: 1.25rem;
}

.placeholder-content p {
  margin: 0.5rem 0;
  color: #7f8c8d;
  line-height: 1.5;
}

.placeholder-hint {
  margin-top: 1rem;
  padding: 0.75rem;
  background-color: #fff3cd;
  border-left: 4px solid #ffc107;
  border-radius: 4px;
  color: #856404;
  font-size: 0.9rem;
}

.btn-primary {
  padding: 0.75rem 1.5rem;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-primary:hover:not(.disabled) {
  background-color: #2980b9;
}

.btn-primary.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.error-message {
  background-color: #fee;
  color: #c33;
  padding: 0.75rem;
  border-radius: 4px;
  text-align: center;
}

/* Upload Progress Styles */
.upload-progress-container {
  background: white;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.upload-progress-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.upload-progress-stage {
  font-weight: 500;
  color: #2c3e50;
}

.upload-progress-percent {
  font-weight: 600;
  color: #3498db;
}

.upload-progress-bar-bg {
  height: 8px;
  background-color: #ecf0f1;
  border-radius: 4px;
  overflow: hidden;
}

.upload-progress-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #3498db, #2980b9);
  border-radius: 4px;
  transition: width 0.3s ease;
}

.upload-progress-message {
  margin-top: 0.5rem;
  font-size: 0.875rem;
  color: #7f8c8d;
  text-align: center;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .rag-header {
    flex-direction: column;
    gap: 0.75rem;
    padding: 0.75rem;
  }

  .rag-header h2 {
    font-size: 1.1rem;
  }

  .rag-header-actions {
    flex-wrap: wrap;
    justify-content: center;
  }

  .rag-content {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  .documents-list, .pdf-viewer-container {
    padding: 0.75rem;
  }

  .pdf-viewer-container {
    min-height: 300px;
  }

  .placeholder-icon {
    font-size: 3rem;
  }

  .placeholder-content h3 {
    font-size: 1.1rem;
  }

  .placeholder-content p {
    font-size: 0.9rem;
  }

  .doc-item {
    padding: 0.6rem;
  }

  .upload-progress-container {
    padding: 0.75rem;
  }

  .btn-primary, .btn-danger {
    padding: 0.6rem 1rem;
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .rag-header {
    padding: 0.5rem;
  }

  .rag-header h2 {
    font-size: 1rem;
  }

  .rag-header-actions {
    gap: 0.5rem;
  }

  .documents-list h3 {
    font-size: 1rem;
  }

  .doc-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .doc-actions {
    width: 100%;
    justify-content: flex-end;
  }

  .doc-name {
    font-size: 0.9rem;
  }

  .doc-date {
    font-size: 0.8rem;
  }

  .btn-icon {
    font-size: 1.1rem;
    padding: 0.3rem;
  }

  .upload-progress-stage {
    font-size: 0.9rem;
  }

  .upload-progress-message {
    font-size: 0.8rem;
  }

  .pdf-viewer-container {
    min-height: 250px;
  }

  .placeholder-icon {
    font-size: 2.5rem;
  }

  .placeholder-content h3 {
    font-size: 1rem;
  }

  .placeholder-content p {
    font-size: 0.85rem;
  }

  .pdf-viewer-placeholder {
    padding: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/RagPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".rag-page {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.rag-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: white;\n  padding: 1rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.rag-header-actions {\n  display: flex;\n  gap: 0.75rem;\n  align-items: center;\n}\n\n.rag-header-actions .btn-danger {\n  padding: 0.75rem 1rem;\n  background-color: #e74c3c;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.rag-header-actions .btn-danger:hover:not(:disabled) {\n  background-color: #c0392b;\n}\n\n.rag-header-actions .btn-danger:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.rag-header h2 {\n  margin: 0;\n  color: #2c3e50;\n}\n\n.rag-content {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  gap: 1rem;\n  flex: 1;\n}\n\n.documents-list {\n  background: white;\n  padding: 1rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.documents-list h3 {\n  margin-top: 0;\n  color: #2c3e50;\n}\n\n.empty-state {\n  color: #7f8c8d;\n  text-align: center;\n  padding: 2rem 0;\n}\n\n.doc-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.doc-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.75rem;\n  border-bottom: 1px solid #eee;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.doc-item:hover {\n  background-color: #f8f9fa;\n}\n\n.doc-item.active {\n  background-color: #e3f2fd;\n}\n\n.doc-item:last-child {\n  border-bottom: none;\n}\n\n.doc-info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.doc-name {\n  font-weight: 500;\n  color: #2c3e50;\n}\n\n.doc-date {\n  font-size: 0.875rem;\n  color: #7f8c8d;\n}\n\n.doc-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.btn-icon {\n  background: none;\n  border: none;\n  font-size: 1.25rem;\n  cursor: pointer;\n  padding: 0.25rem;\n  opacity: 0.7;\n  transition: opacity 0.2s;\n}\n\n.btn-icon:hover {\n  opacity: 1;\n}\n\n.btn-danger:hover {\n  color: #e74c3c;\n}\n\n.pdf-viewer-container {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  min-height: 500px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pdf-viewer-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n}\n\n.placeholder-content {\n  text-align: center;\n  color: #7f8c8d;\n}\n\n.placeholder-icon {\n  font-size: 4rem;\n  margin-bottom: 1rem;\n  opacity: 0.5;\n}\n\n.placeholder-content h3 {\n  margin: 0 0 0.5rem 0;\n  color: #2c3e50;\n  font-size: 1.25rem;\n}\n\n.placeholder-content p {\n  margin: 0.5rem 0;\n  color: #7f8c8d;\n  line-height: 1.5;\n}\n\n.placeholder-hint {\n  margin-top: 1rem;\n  padding: 0.75rem;\n  background-color: #fff3cd;\n  border-left: 4px solid #ffc107;\n  border-radius: 4px;\n  color: #856404;\n  font-size: 0.9rem;\n}\n\n.btn-primary {\n  padding: 0.75rem 1.5rem;\n  background-color: #3498db;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.btn-primary:hover:not(.disabled) {\n  background-color: #2980b9;\n}\n\n.btn-primary.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.error-message {\n  background-color: #fee;\n  color: #c33;\n  padding: 0.75rem;\n  border-radius: 4px;\n  text-align: center;\n}\n\n/* Upload Progress Styles */\n.upload-progress-container {\n  background: white;\n  padding: 1rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.upload-progress-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n\n.upload-progress-stage {\n  font-weight: 500;\n  color: #2c3e50;\n}\n\n.upload-progress-percent {\n  font-weight: 600;\n  color: #3498db;\n}\n\n.upload-progress-bar-bg {\n  height: 8px;\n  background-color: #ecf0f1;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.upload-progress-bar-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #3498db, #2980b9);\n  border-radius: 4px;\n  transition: width 0.3s ease;\n}\n\n.upload-progress-message {\n  margin-top: 0.5rem;\n  font-size: 0.875rem;\n  color: #7f8c8d;\n  text-align: center;\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .rag-header {\n    flex-direction: column;\n    gap: 0.75rem;\n    padding: 0.75rem;\n  }\n\n  .rag-header h2 {\n    font-size: 1.1rem;\n  }\n\n  .rag-header-actions {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  .rag-content {\n    grid-template-columns: 1fr;\n    gap: 0.75rem;\n  }\n\n  .documents-list, .pdf-viewer-container {\n    padding: 0.75rem;\n  }\n\n  .pdf-viewer-container {\n    min-height: 300px;\n  }\n\n  .placeholder-icon {\n    font-size: 3rem;\n  }\n\n  .placeholder-content h3 {\n    font-size: 1.1rem;\n  }\n\n  .placeholder-content p {\n    font-size: 0.9rem;\n  }\n\n  .doc-item {\n    padding: 0.6rem;\n  }\n\n  .upload-progress-container {\n    padding: 0.75rem;\n  }\n\n  .btn-primary, .btn-danger {\n    padding: 0.6rem 1rem;\n    font-size: 0.9rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .rag-header {\n    padding: 0.5rem;\n  }\n\n  .rag-header h2 {\n    font-size: 1rem;\n  }\n\n  .rag-header-actions {\n    gap: 0.5rem;\n  }\n\n  .documents-list h3 {\n    font-size: 1rem;\n  }\n\n  .doc-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n\n  .doc-actions {\n    width: 100%;\n    justify-content: flex-end;\n  }\n\n  .doc-name {\n    font-size: 0.9rem;\n  }\n\n  .doc-date {\n    font-size: 0.8rem;\n  }\n\n  .btn-icon {\n    font-size: 1.1rem;\n    padding: 0.3rem;\n  }\n\n  .upload-progress-stage {\n    font-size: 0.9rem;\n  }\n\n  .upload-progress-message {\n    font-size: 0.8rem;\n  }\n\n  .pdf-viewer-container {\n    min-height: 250px;\n  }\n\n  .placeholder-icon {\n    font-size: 2.5rem;\n  }\n\n  .placeholder-content h3 {\n    font-size: 1rem;\n  }\n\n  .placeholder-content p {\n    font-size: 0.85rem;\n  }\n\n  .pdf-viewer-placeholder {\n    padding: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
